// src/pages/TermosDeUso.js

import React from "react";
import "./Terms.css"; // caso você use o CSS padrão das páginas

const Terms = () => {
  return (
    <div className="pagina-container">
      <h1>Termos de Uso – Aplicativos</h1>
      <p><strong>Última atualização:</strong> [29/11/2025]</p>

      <h2>1. Sobre o Aplicativo</h2>
      <p>
        Os aplicativos da Custos Agro são para simulação econômica destinado a produtores
        de leite, café, grãos e gado. Eles permitem calcular custos, rentabilidade, ponto de equilíbrio e
        outros indicadores com base nas informações fornecidas pelo usuário.
      </p>
      <ul>
        <li>Não armazena dados pessoais ou financeiros inseridos</li>
        <li>Não exige conexão com a internet para funcionar</li>
        <li>Não realiza gestão de fazendas</li>
        <li>Não coleta dados sensíveis, exceto informações mínimas necessárias para autenticação e controle de assinaturas</li>
      </ul>

      <h2>2. Assinaturas e Pagamentos</h2>
      <p>Os aplicativos oferecem planos de assinatura auto-renováveis:</p>
      <ul>
        <li>Plano Mensal</li>
        <li>Plano Trimestral</li>
        <li>Plano Anual</li>
      </ul>
      <p>
        Os valores são cobrados pela App Store através da sua conta Apple ID.
      </p>

      <h3>2.1 Renovação Automática</h3>
      <p>
        As assinaturas são renovadas automaticamente ao final de cada período, a
        menos que você cancele manualmente. A App Store efetuará a cobrança até 24
        horas antes do término da assinatura atual.
      </p>

      <h3>2.2 Cancelamento</h3>
      <p>
        Você pode cancelar sua assinatura a qualquer momento pela App Store:
      </p>
      <ol>
        <li>Abra o app Ajustes</li>
        <li>Toque no seu nome</li>
        <li>Selecione "Assinaturas"</li>
        <li>Escolha “CalcLeite” ou outro app aque estiver ativo</li>
        <li>Toque em “Cancelar Assinatura”</li>
      </ol>
      <p>
        O cancelamento impede futuras cobranças, mas não gera reembolso pelo período
        já pago.
      </p>

      <h3>2.3 Gerenciamento</h3>
      <p>
        Você pode gerenciar suas assinaturas diretamente na App Store.
        Mais informações:{" "}
        <a
          href="https://support.apple.com/pt-br/HT202039"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://support.apple.com/pt-br/HT202039
        </a>
      </p>

      <h2>3. Período de Acesso / Conteúdos Disponíveis</h2>
      <p>Enquanto sua assinatura estiver ativa, você terá acesso a:</p>
      <ul>
        <li>Todos os cálculos e simuladores</li>
        <li>Relatórios em PDF</li>
        <li>Funcionalidades completas do app</li>
        <li>Atualizações e melhorias incluídas no plano</li>
      </ul>

      <h2>4. Política de Privacidade</h2>
      <p>
        Nossa Política de Privacidade está disponível em:{" "}
        <a
          href="https://custosagro.com.br/politica-privacidade"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://custosagro.com.br/politica-privacidade
        </a>
      </p>

      <h2>5. Uso Permitido</h2>
      <p>Você concorda em utilizar os aplicativos da Custos Agro apenas para fins pessoais e legais.</p>
      <ul>
        <li>É proibido copiar ou vender partes do app</li>
        <li>Não é permitido engenharia reversa</li>
        <li>Não é permitido uso fraudulento ou abusivo</li>
      </ul>

      <h2>6. Limitação de Responsabilidade</h2>
      <p>
        Os aplicativos da Custos Agro fornecem simulações baseadas nas informações fornecidas pelo
        usuário. Não garantimos resultados financeiros. O usuário é
        responsável por qualquer decisão tomada com base nos cálculos exibidos no app.
      </p>

      <h2>7. Alterações no Serviço ou Termos</h2>
      <p>
        Podemos atualizar estes Termos a qualquer momento. O uso continuado do app
        após alterações significa que você concorda com os novos Termos.
      </p>

      <h2>8. Contato</h2>
      <p>
        Para suporte, entre em contato:<br />
        <strong>contato@custosagro.com.br</strong>
      </p>

      <h2>9. Aceitação dos Termos</h2>
      <p>
        Ao utilizar os aplicativos da Custos Agro, você confirma que leu e aceita estes Termos de Uso.
      </p>
    </div>
  );
};

export default Terms;
